export let emptyFocused = "CvNWE";
export let emptyOther = "LTCJJe";
export let emptyFolder = "P7YSXd";
export default {emptyFocused,emptyOther,emptyFolder};